// import React, { useState } from 'react';
// import moment from 'moment-timezone';

// const TimeZoneSelect = () => {
//   const [selectedTimeZone, setSelectedTimeZone] = useState('');
//   const timeZones = moment.tz.names();

//   console.log(selectedTimeZone,"selectedTimeZone")

//   const handleTimeZoneChange = (e) => {
//     setSelectedTimeZone(e.target.value);
//   };

//   return (
//     <div>
//       <h2>Select a Time Zone</h2>
//       <select value={selectedTimeZone} onChange={handleTimeZoneChange}>
//         <option value="">Select a time zone</option>
//         {timeZones.map((zone) => (
//           <option key={zone} value={zone}>
//             {zone}
//           </option>
//         ))}
//       </select>
//       {selectedTimeZone && (
//         <p>Selected Time Zone: {selectedTimeZone}</p>
//       )}
//     </div>
//   );
// };

// export default TimeZoneSelect;
import React, { useState } from 'react';
import moment from 'moment-timezone';

const TimeZoneSelect = ({selectedTimeZone,setSelectedTimeZone}) => {
//   const [selectedTimeZone, setSelectedTimeZone] = useState('');
  const timeZones = moment.tz.names();
  const handleTimeZoneChange = (e) => {
    setSelectedTimeZone(e.target.value);
  };

  // Function to get the offset for the selected time zone
  const getTimeZoneOffset = () => {
    if (selectedTimeZone) {
      const now = moment();
      const offset = now.tz(selectedTimeZone).format('Z');
      return offset;
    }
    return '';
  };

  return (
    <div>
      {/* <h2>Select a Time Zone</h2> */}
      <select value={selectedTimeZone} onChange={handleTimeZoneChange} style={{ width: "100%", padding: "18px", borderRadius: "5px", marginBottom: "11px", marginTop: "10px" }}>
        <option value="">Select a time zone</option>
        {timeZones.map((zone) => (
          <option key={zone} value={zone}>
            {zone}
          </option>
        ))}
      </select>
      {/* {selectedTimeZone && (
        <div>
          <p>Selected Time Zone: {selectedTimeZone}</p>
          <p>Offset: {getTimeZoneOffset()}</p>
        </div>
      )} */}
    </div>
  );
};

export default TimeZoneSelect;

